import Swal from 'sweetalert2';

const base = {
  confirmButtonColor: '#00a76f',
  cancelButtonColor: '#adb5bd',
  buttonsStyling: true,
  customClass: {
    confirmButton: 'swal-confirm-btn',
    cancelButton: 'swal-cancel-btn',
    popup: 'swal-popup',
    title: 'swal-title',
    htmlContainer: 'swal-html',
  },
};

export const toast = (type = 'success', title = '', message = '') =>
  Swal.fire({
    toast: true,
    position: 'top-end',
    icon: type,
    title: message || title,
    showConfirmButton: false,
    timer: 2500,
    timerProgressBar: true,
    ...base,
  });

export const confirmDialog = (options = {}) =>
  Swal.fire({
    title: options.title || 'Are you sure?',
    text: options.text || 'You will not be able to revert this!',
    icon: options.icon || 'warning',
    showCancelButton: true,
    confirmButtonText: options.confirmText || 'Yes, proceed!',
    cancelButtonText: options.cancelText || 'Cancel',
    ...base,
  });

export const confirmDelete = (name = 'this item') =>
  confirmDialog({
    title: 'Delete record?',
    text: `Are you sure you want to delete ${name}?`,
    confirmText: 'Yes, delete it!',
  });

export const confirmAction = (title, text = '', confirmText = 'Yes, proceed!') =>
  confirmDialog({
    title,
    text,
    confirmText,
  });

export const showLoading = (title = 'Please wait...') =>
  Swal.fire({
    title,
    allowOutsideClick: false,
    allowEscapeKey: false,
    showConfirmButton: false,
    didOpen: () => Swal.showLoading(),
  });

export const showSuccess = (title, message = '') =>
  Swal.fire({
    title,
    text: message,
    icon: 'success',
    confirmButtonText: 'OK',
    ...base,
  });

export const showError = (title, message = '') =>
  Swal.fire({
    title,
    text: message,
    icon: 'error',
    confirmButtonText: 'OK',
    ...base,
  });